<script setup>
import { ref, onMounted } from "vue"
import { cn } from "@/lib/utils"
import { linkLabel } from "@/lib/a11y"
const props = defineProps({
  modelValue: { type: [String, Number], default: "" },
  class: { type: null, default: "" },
})
defineEmits(["update:modelValue"])
const el = ref(null)
onMounted(() => linkLabel(el.value))
defineExpose({ focus: () => el.value?.focus(), el })
</script>

<template>
  <input
    ref="el"
    :value="modelValue"
    @input="$emit('update:modelValue', $event.target.value)"
    :class="cn(
      'flex h-10 w-full rounded-md border border-input bg-card px-3 py-2 text-sm ring-offset-background',
      'placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2',
      'focus-visible:ring-ring focus-visible:ring-offset-1 focus-visible:border-primary transition',
      'disabled:cursor-not-allowed disabled:opacity-50', props.class)" />
</template>